import Html from "../assets/images/html5.svg";
import Css from "../assets/images/css3.svg";
import JavaScript from "../assets/images/javascript.svg";
import Sass from "../assets/images/sass.svg";
import Bootstrap from "../assets/images/bootstrap.svg";
import React from "../assets/images/react.svg";
import Redux from "../assets/images/redux.svg";
import Git from "../assets/images/git.svg";
import TypeScript from "../assets/images/typescript.png";

export const skillsData = [
  {
    name: "HTML5",
    image: <img src={Html} alt="Html" />,
  },
  {
    name: "CSS3",
    image: <img src={Css} alt="Css" />,
  },
  {
    name: "JavaScript",
    image: <img src={JavaScript} alt="JavaScript" />,
  },
  {
    name: "TypeScript",
    image: <img src={TypeScript} alt="Typescript" />,
  },
  {
    name: "SASS",
    image: <img src={Sass} alt="Sass" />,
  },
  {
    name: "Bootstrap",
    image: <img src={Bootstrap} alt="Bootstrap" />,
  },
  {
    name: "React",
    image: <img src={React} alt="React" />,
  },
  {
    name: "Redux",
    image: <img src={Redux} alt="Redux" />,
  },
  {
    name: "Git",
    image: <img src={Git} alt="Git" />,
  },
];
